import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  TableCell,
  TableSortLabel,
  // TablePagination,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Typography,
  Menu,
} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import Snackbar from "@mui/material/Snackbar";
import { getincidents } from "Samarth Module/api/getIncidents";
import { useMsal } from "@azure/msal-react";
import { styled } from "@mui/system";
import { updateIncidentPriority } from "Samarth Module/api/updatePriority";
import { assignTicket } from "Samarth Module/api/assignTicket";
import { updateTicketStatus } from "Samarth Module/api/updateTicketStatus";
import { getBauTeamDetails } from "Samarth Module/api/getBauTeamDetails";
import { getTicketKpis } from "Samarth Module/api/getTicketKpis";
import { updateHolidaysList } from "Samarth Module/api/updateHolidaysList";
import { exportTicketReport } from "Samarth Module/api/exportTicketReport";
import { postEffortDetails } from "Samarth Module/api/postEffortDetails";
import { syncBauTeamdetails } from "Samarth Module/api/syncBauTeamDetails";
import KpiCards from "./KpiCards";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ReplayTwoToneIcon from "@mui/icons-material/ReplayTwoTone";
import newExcel from "../../../../assets/images/Excel.svg";
import InputAdornment from "@mui/material/InputAdornment";
import MoreVertTwoToneIcon from "@mui/icons-material/MoreVertTwoTone";
import readXlsxFile from "read-excel-file/browser";
import { getTicketDetails } from "Samarth Module/api/getTicketDetails";
import { postTicketComment } from "Samarth Module/api/postTicketComment";
import { saveTicketRca } from "Samarth Module/api/saveTicketRca";
import { getInternalTeam } from "Samarth Module/api/getInternalTeam";
import CustomCalendar from "../components/customCalendar";
import RcaDialog from "../components/dialogs/rcaDialog";
import ViewTicketDetails from "../components/dialogs/ticketDetails";
import BauTeamMembers from "../components/dialogs/bauTeamMembers";
import ExportTicketDetails from "../components/dialogs/exportTickets";
import InvalidReason from "../components/dialogs/invalidTicketReason";
import HolidayListupload from "../components/dialogs/holidayListUpload";
import EffortDetails from "../components/dialogs/efforDetails";
import TableSkeleton from "../components/skeleton/tableSkeleton";
import TicketsTable from "../components/ticketsTable";
import { getUserAccess } from "../components/utils/helper/ticketTableHelper";
import {
  summaryCategories,
  summaryStatuses,
} from "../components/constants/ticketConstants";
import { EPICS_DATA } from "Samarth Module/components/incidentCreation/IncidentForm";
import { updateTicketDetails } from "Samarth Module/api/updateTicketDetails";

export const baseFontStyle = { fontFamily: "Unilever Shilling" };
export const menuItemTextStyle = {
  ...baseFontStyle,
  fontSize: "0.75rem",
  fontWeight: 400,
};

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    fontFamily: "Unilever Shilling",
    backgroundColor: "#2036C7",
    color: "#fff",
    textAlign: "center",
    padding: "3px",
    fontSize: "0.75rem",
    fontWeight: 400,
    border: "1px solid #EAECF0",
    position: "sticky",
    top: 0,
  },
  "&.MuiTableCell-body": {
    fontFamily: "Unilever Shilling",
    fontSize: 12,
    fontWeight: 400,
    padding: "3px",
    color: "#2B2B2B",
    border: "1px solid #EAECF0",
    textAlign: "center",
  },
}));

export const StyledSortLabel = styled(TableSortLabel)(({ theme }) => ({
  "&.MuiTableSortLabel-root": {
    color: "#fff",
    "&:active": {
      color: "#fff",
    },
  },
  "&.MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon": {
    color: "#fff",
    "&:active": {
      color: "#fff",
    },
  },
}));

export default function TicketsPage() {
  const [state, setState] = useState({
    snackbarOpen: false,
    vertical: "top",
    horizontal: "right",
    message: "",
    backgroundColor: "#000",
    textColor: "#fff",
  });
  const [loading, setLoading] = useState(true);
  const [kpiLoading, setKpiLoading] = useState(true);
  const [error, setError] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [ticketKpis, setTicketKpis] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [epicNameFilter, setEpicNameFilter] = useState("");
  const [assignedFilter, setAssignedFilter] = useState("");
  const [pageFilter, setPageFilter] = useState("");
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("created_on");
  const [sortDirection, setSortDirection] = useState("desc");
  const [page, setPage] = useState(1);
  const rowsPerPage = 20;
  const [pagesData, setPagesData] = useState({});
  // const [totalRecords, setTotalRecords] = useState(0);
  // const [totalPagesCount, setTotalPagesCount] = useState(1);
  // const [isAllDataLoaded, setIsAllDataLoaded] = useState(false);
  const [bauTeamDetails, setBauTeamDetails] = useState([]);
  const [severityEdit, setSeverityedit] = useState({});
  const [invalidDialog, setInvalidDialog] = useState({
    open: false,
    ticketId: null,
    category: "",
    reason: "",
    othersReason: "",
  });
  const [effortDialog, setEffortDialog] = useState({
    open: false,
    ticketId: null,
    rows: [{ type: "", effort: "", startDate: "", endDate: "" }],
  });
  const [pendingAssignments, setPendingAssignments] = useState({});
  const [openAssignment, setOpenAssignment] = useState(null);
  const [exportDialog, setExportDialog] = useState({
    open: false,
    fromDate: new Date(),
    toDate: new Date(),
    category: [],
    reportedBy: [],
    pageName: [],
    assignedTo: [],
    status: [],
    slaStatus: [],
  });
  const [calendarAnchor, setCalendarAnchor] = useState(null);
  const [activeDateField, setActiveDateField] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [effortLoading, setEffortLoading] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [holidayDialog, setHolidayDialog] = useState({
    open: false,
  });

  const [holidayFile, setHolidayFile] = useState(null);
  const [holidayPayload, setHolidayPayload] = useState([]);
  const [bauTeamDialog, setBauTeamDialog] = useState({
    open: false,
  });
  const [editingRows, setEditingRows] = useState({});
  const [bauTeamRows, setBauTeamRows] = useState([]);
  const [internalTeam, setInternalTeam] = useState([]);
  const [ticketViewDialog, setTicketViewDialog] = useState({
    open: false,
    ticket: null,
  });

  const [newComment, setNewComment] = useState("");
  const [ticketDetails, setTicketDetails] = useState(null);
  const [ticketDetailsLoading, setTicketDetailsLoading] = useState(false);
  const [rcaText, setRcaText] = useState("");
  const [rcaDialog, setRcaDialog] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  dayjs.extend(customParseFormat);
  const { accounts } = useMsal();
  const activeAccount = accounts[0];
  const { vertical, horizontal, snackbarOpen, backgroundColor, textColor } =
    state;
  const getName = () => {
    const nameParts = activeAccount.name?.split(", ") || [];
    if (nameParts.length > 1) {
      setFirstName(nameParts[1] + " " + nameParts[0]);
    } else {
      setFirstName(activeAccount.name || "");
    }
  };
  useEffect(() => {
    const storedUserInfo = localStorage.getItem("UserInfo");
    if (storedUserInfo && JSON.parse(storedUserInfo)) {
      const parsedUserInfo = JSON.parse(storedUserInfo)?.user_info;

      setUserInfo({
        accessType: parsedUserInfo.accessType,
        email: parsedUserInfo.email,
        id: parsedUserInfo.id,
        name: parsedUserInfo.name,
        persona: parsedUserInfo.persona,
        scope: parsedUserInfo.scope,
        scope_value: parsedUserInfo.scope_value
          ? JSON.parse(parsedUserInfo.scope_value)
          : [],
        userType: parsedUserInfo.userType,
      });
    } else {
      setUserInfo({});
    }
  }, []);
  const currentBauUser = useMemo(
    () => bauTeamDetails?.find((member) => member.user_id === userInfo?.id),
    [bauTeamDetails, userInfo],
  );

  const userAccess = useMemo(() => {
    if (
      !currentBauUser?.role &&
      !userInfo?.persona &&
      !(bauTeamDetails?.length > 0)
    )
      return;
    return getUserAccess(userInfo?.persona, currentBauUser?.role);
  }, [userInfo, currentBauUser?.role, bauTeamDetails]);

  const accessLoading = useMemo(
    () =>
      !userInfo?.persona ||
      (bauTeamDetails.length === 0 &&
        userInfo?.persona?.toLowerCase() === "ey team"),
    [userInfo, bauTeamDetails],
  );

  useEffect(() => getName(), []);

  const fetchBauTeamDetails = async () => {
    try {
      const response = await getBauTeamDetails();

      if (response?.bau_team?.length > 0) {
        setBauTeamDetails(response?.bau_team || []);
        setBauTeamRows(response?.bau_team || []);
      }
    } catch (error) {
      const message =
        error instanceof Error
          ? error?.message
          : "Failed to load BAU team details.";
      toastMessage(
        message,
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const fetchKPIs = async (silent = false) => {
    !silent && setKpiLoading(true);
    try {
      const response = await getTicketKpis();
      setTicketKpis(response);
    } catch (error) {
      console.error("Error fetching KPIs details:", error);
      toastMessage(
        "Failed to fetch KPI details.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    } finally {
      setKpiLoading(false);
    }
  };

  useEffect(() => {
    fetchBauTeamDetails();
    fetchKPIs();
  }, []);

  const { overallStartDate, overallEndDate, totalHours } = useMemo(() => {
    const startDates = effortDialog.rows
      .filter((row) => row.startDate)
      .map((row) => dayjs(row.startDate));

    const endDates = effortDialog.rows
      .filter((row) => row.endDate)
      .map((row) => dayjs(row.endDate));

    const overallStartDate =
      startDates.length > 0
        ? dayjs(Math.min(...startDates.map((d) => d.valueOf()))).format(
            "DD-MM-YYYY",
          )
        : "";

    const overallEndDate =
      endDates.length > 0
        ? dayjs(Math.max(...endDates.map((d) => d.valueOf()))).format(
            "DD-MM-YYYY",
          )
        : "";
    const totalHours = effortDialog.rows.reduce(
      (sum, row) => sum + (Number(row.effort) || 0),
      0,
    );
    return { overallStartDate, overallEndDate, totalHours };
  }, [effortDialog?.rows]);

  const toastMessage = (message, additional, duration = 2500) => {
    setState({
      ...state,
      snackbarOpen: true,
      message: message,
      ...additional,
    });
    setTimeout(() => {
      setState({
        ...state,
        snackbarOpen: false,
        message: "",
        backgroundColor: "#000000",
        textColor: "#fff",
      });
    }, duration);
  };

  const twoMonthsAgo = dayjs().subtract(2, "month").toDate();

  const openCalendar = (event, field) => {
    setCalendarAnchor(event.currentTarget);
    setActiveDateField(field);
  };

  const handleDateSelect = (date) => {
    setExportDialog((prev) => {
      const updated = {
        ...prev,
        [activeDateField]: date,
      };

      return updated;
    });

    setCalendarAnchor(null);
    setActiveDateField(null);
  };

  const updateTicketInPages = (ticketId, updater) => {
    setPagesData((prev) =>
      Object.fromEntries(
        Object.entries(prev).map(([pageKey, pageTickets]) => [
          pageKey,
          pageTickets.map((ticket) =>
            ticket.ticket_id === ticketId ? updater(ticket) : ticket,
          ),
        ]),
      ),
    );
  };

  const handleAssignedChange = async (ticketId, value) => {
    try {
      await assignTicket({
        ticket_id: ticketId,
        assigned_to: value,
        updated_by: userInfo?.name || firstName,
      });
      updateTicketInPages(ticketId, (ticket) => ({
        ...ticket,
        assigned_to: value,
      }));
      setTimeout(() => {
        toastMessage(
          `Ticket assigned to ${value} successfully.`,
          {
            backgroundColor: "var(--primary-unilever-color)",
            textColor: "#fff",
          },
          4000,
        );
      }, 100);
      await fetchTickets(true);
    } catch (error) {
      toastMessage(
        "Failed to update the assignment.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        2500,
      );
      return;
    }
  };

  const handleAssignmentSelection = (ticketId, value) => {
    setPendingAssignments((prev) => ({
      ...prev,
      [ticketId]: value,
    }));
  };

  const handleExportFieldChange = (e) => {
    const { name, value } = e.target;
    setExportDialog((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAssignmentDone = async (ticket) => {
    const selectedValue =
      pendingAssignments[ticket.ticket_id]
        ?.filter(
          (item) => item !== "BAU Delivery Manager" && item !== "BAU Lead",
        )
        .join(", ") || ticket.assigned_to;

    if (!selectedValue || selectedValue === ticket.assigned_to) {
      return;
    }

    await handleAssignedChange(ticket.ticket_id, selectedValue);

    setPendingAssignments((prev) => {
      const updated = { ...prev };
      delete updated[ticket.ticket_id];
      return updated;
    });
  };

  const handleSeverityChange = async (ticketId, value, category) => {
    try {
      await updateIncidentPriority({
        ticket_id: ticketId,
        new_priority: value,
        category,
        updated_by: userInfo?.name || firstName,
      });
      const INCIDENT_PRIORITY = {
        P1: 4,
        P2: 8,
        P3: 24,
        P4: 168,
      };
      updateTicketInPages(ticketId, (ticket) => ({
        ...ticket,
        severity: value,
        sla_hours: category === "Incident" ? INCIDENT_PRIORITY[value] : null,
      }));
      toastMessage(
        `Priority updated to ${value} successfully.`,
        {
          backgroundColor: "var(--primary-unilever-color)",
          textColor: "#fff",
        },
        4000,
      );
      await fetchTickets(true);
    } catch (error) {
      toastMessage(
        "Failed to update the Priority.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        2500,
      );
      return;
    }
  };

  const handleStatusChange = async (ticketId, category, value) => {
    try {
      await updateTicketStatus({
        ticket_id: ticketId,
        new_status: value,
        updated_by: userInfo?.name || firstName,
        category: category,
      });

      updateTicketInPages(ticketId, (ticket) => ({
        ...ticket,
        status: value,
      }));

      toastMessage(
        `Status updated to ${value} successfully.`,
        {
          backgroundColor: "var(--primary-unilever-color)",
          textColor: "#fff",
        },
        4000,
      );
      await fetchTickets(true);
      if (["New", "Work in progress", "Closed"].includes(value)) {
        await fetchKPIs(true);
      }
    } catch (error) {
      toastMessage(
        "Failed to update the status.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        2500,
      );
      return;
    }
  };

  const parseIncidentsResponse = (response) => {
    const responseObject = response ?? {};
    const hasPaginationMeta =
      responseObject &&
      typeof responseObject === "object" &&
      (responseObject.total_count != null ||
        responseObject.total_pages != null ||
        responseObject.totalCount != null ||
        responseObject.totalPages != null ||
        responseObject.page != null ||
        responseObject.count != null ||
        responseObject.pagination != null);

    const payload =
      Array.isArray(responseObject.data) && !hasPaginationMeta
        ? responseObject.data
        : responseObject;

    const incidents = Array.isArray(payload)
      ? payload
      : (payload?.data ?? payload?.incidents ?? payload?.tickets ?? []);

    // const totalCount =
    //   responseObject?.total_count ??
    //   responseObject?.totalCount ??
    //   responseObject?.totalRecords ??
    //   responseObject?.total_records ??
    //   responseObject?.count ??
    //   responseObject?.totalItems ??
    //   responseObject?.pagination?.total_count ??
    //   responseObject?.pagination?.totalCount ??
    //   responseObject?.pagination?.totalRecords ??
    //   responseObject?.pagination?.total_records ??
    //   responseObject?.pagination?.totalItems ??
    //   0;

    // const totalPagesCount =
    //   responseObject?.total_pages ??
    //   responseObject?.totalPages ??
    //   responseObject?.pagination?.total_pages ??
    //   responseObject?.pagination?.totalPages ??
    //   0;

    return {
      incidents,
      // totalCount, totalPagesCount
    };
  };

  const fetchTickets = async (silent = false) => {
    if (!silent) {
      setLoading(true);
      setError(null);
    }
    try {
      const response = await getincidents({
        reported_by: userInfo?.name || firstName,
        page,
        page_size: rowsPerPage,
      });
      const {
        incidents,
        //  totalCount, totalPagesCount
      } = parseIncidentsResponse(response);

      setPagesData((prev) => ({
        ...prev,
        [page]: incidents,
      }));

      // if (totalCount && totalCount > 0) {
      //   setTotalRecords(totalCount);
      // } else {
      //   setTotalRecords((prevTotal) => prevTotal || incidents.length * page);
      // }

      // if (totalPagesCount && totalPagesCount > 0) {
      // setTotalPagesCount(totalPagesCount);
      // if (page >= totalPagesCount) {
      //   setIsAllDataLoaded(true);
      // }
      // }

      if (incidents.length < rowsPerPage) {
        // setIsAllDataLoaded(true);
        // setTotalRecords((prevTotal) =>
        //   totalCount > 0
        //     ? totalCount
        //     : Math.max(
        //         prevTotal || 0,
        //         (page - 1) * rowsPerPage + incidents.length,
        //       ),
        // );
        // if (!totalPagesCount || totalPagesCount === 0) {
        //   setTotalPagesCount(Math.max(1, page));
        // }
      }
    } catch (fetchError) {
      console.error("Error fetching incidents:", fetchError);
      setError("Unable to load ticket details. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userInfo?.name) return;
    if (pagesData[page]) return;
    // if (isAllDataLoaded) return;

    fetchTickets();
  }, [
    userInfo?.name,
    page,
    rowsPerPage,
    pagesData,
    //  isAllDataLoaded
  ]);

  const currentPageTickets = pagesData[page] || [];

  const filteredTickets = currentPageTickets.filter((ticket) => {
    const matchesCategory = categoryFilter
      ? ticket.category?.trim()?.toLowerCase() ===
        categoryFilter?.trim()?.toLowerCase()
      : true;
    const statusMap = {
      new: ["new"],
      "work in progress": [
        "work in progress",
        "awaiting for users confirmation",
        "awaiting for business inputs",
        "bau team validation",
      ],
      closed: ["closed", "resolve", "converted to cr"],
    };

    const normalizedStatusFilter = statusFilter?.trim()?.toLowerCase();
    const normalizedTicketStatus = ticket.status?.trim()?.toLowerCase();

    const excludedStatuses = ["on hold", "invalid"];
    let matchesStatus = true;
    if (normalizedStatusFilter) {
      matchesStatus =
        !excludedStatuses.includes(normalizedTicketStatus) &&
        statusMap[normalizedStatusFilter]?.includes(normalizedTicketStatus);
    }

    const matchEpicName = epicNameFilter
      ? ticket.epic_name === epicNameFilter
      : true;
    const matchesAssigned = assignedFilter
      ? ticket.assigned_to.includes(assignedFilter)
      : true;
    const matchesPage = pageFilter ? ticket.page_name === pageFilter : true;
    const matchesSearch = searchText
      ? [
          ticket.ticket_key,
          ticket.title,
          ticket.category,
          ticket.page_name,
          ticket.reported_by,
          ticket.status,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase())
      : true;

    return (
      matchEpicName &&
      matchesCategory &&
      matchesStatus &&
      matchesAssigned &&
      matchesPage &&
      matchesSearch
    );
  });

  const getSeverityRank = (severity) => {
    const rank = parseInt(String(severity).replace(/[^0-9]/g, ""), 10);
    return Number.isNaN(rank) ? 99 : rank;
  };

  const getSortValue = (ticket) => {
    if (sortBy === "severity") return getSeverityRank(ticket.severity);
    if (sortBy === "created_on") {
      const timestamp = new Date(ticket.created_on).getTime();
      return Number.isNaN(timestamp) ? 0 : timestamp;
    }
    if (sortBy === "sla") {
      if (ticket.sla_hours != null) {
        return ticket.sla_hours;
      }

      return Number.MAX_SAFE_INTEGER;
    }
    return ticket[sortBy] ?? "";
  };

  const getSLAStatusStyle = (slaStatus) => {
    const normalized = String(slaStatus || "")
      .trim()
      .toLowerCase();
    if (normalized === "on track" || normalized === "met") {
      return { color: "success.main", bgcolor: "success.lighter" };
    }
    if (normalized === "overdue") {
      return { color: "error.main", bgcolor: "error.lighter" };
    }
    if (normalized === "not met" || normalized.includes("at risk")) {
      return { color: "warning.dark", bgcolor: "warning.lighter" };
    }
    if (normalized) {
      return { color: "info.main", bgcolor: "info.lighter" };
    }
    return { color: "text.secondary", bgcolor: "grey.100" };
  };

  const sortedTickets = [...filteredTickets].sort((a, b) => {
    const valueA = getSortValue(a);
    const valueB = getSortValue(b);

    if (valueA < valueB) {
      return sortDirection === "asc" ? -1 : 1;
    }
    if (valueA > valueB) {
      return sortDirection === "asc" ? 1 : -1;
    }
    return 0;
  });

  const loadedTickets = Object.values(pagesData).flat();

  const buildCategoryStatusCounts = () =>
    summaryCategories.reduce((acc, category) => {
      acc[category.key] = {};

      summaryStatuses.forEach((status) => {
        acc[category.key][status.key] = 0;
      });

      return acc;
    }, {});

  const categoryStatusCounts = buildCategoryStatusCounts();

  loadedTickets.forEach((ticket) => {
    if (
      categoryStatusCounts[ticket.category] &&
      ticket.status in categoryStatusCounts[ticket.category]
    ) {
      categoryStatusCounts[ticket.category][ticket.status] += 1;
    }
  });

  const { categoryOptions, statusOptions, assignedOptions, pageOptions } =
    useMemo(() => {
      const categoryOptions = Array.from(
        new Set(loadedTickets.map((ticket) => ticket.category).filter(Boolean)),
      );
      const statusOptions = Array.from(
        new Set(loadedTickets.map((ticket) => ticket.status).filter(Boolean)),
      );
      const assignedOptions = Array.from(
        new Set(
          loadedTickets
            .flatMap((ticket) =>
              (ticket.assigned_to || "").split(",").map((name) => name.trim()),
            )
            .filter(Boolean),
        ),
      );
      const pageOptions = Array.from(
        new Set(
          loadedTickets.map((ticket) => ticket.page_name).filter(Boolean),
        ),
      );

      return {
        categoryOptions,
        statusOptions,
        assignedOptions,
        pageOptions,
      };
    }, [loadedTickets]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleRequestSort = (property) => {
    const isAsc = sortBy === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleOpenEffortDialog = (ticketId) => {
    setEffortDialog({
      open: true,
      ticketId,
      rows: [{ type: "", effort: "" }],
    });
  };

  const handleCloseEffortDialog = () => {
    setEffortDialog({
      open: false,
      ticketId: null,
      rows: [{ type: "", effort: "" }],
    });
  };

  const handleAddEffortRow = () => {
    setEffortDialog((prev) => ({
      ...prev,
      rows: [
        ...prev.rows,
        { type: "", effort: "", startDate: new Date(), endDate: "" },
      ],
    }));
  };

  const handleEffortChange = (index, field, value) => {
    setEffortDialog((prev) => {
      const updatedRows = [...prev.rows];
      const currentRow = updatedRows[index];

      if (
        field === "endDate" &&
        currentRow.startDate &&
        dayjs(value).isBefore(dayjs(currentRow.startDate), "day")
      ) {
        return prev;
      }

      updatedRows[index] = {
        ...currentRow,
        value:
          field === "endDate" || field === "startDate"
            ? dayjs(value).format("YYYY-MM-DD")
            : value,
      };

      // If Start Date changes and End Date becomes invalid,
      // clear End Date automatically
      if (
        field === "startDate" &&
        currentRow.endDate &&
        dayjs(currentRow.endDate).isBefore(dayjs(value), "day")
      ) {
        updatedRows[index].endDate = "";
      }

      updatedRows[index] = {
        ...updatedRows[index],
        [field]: value,
      };

      return {
        ...prev,
        rows: updatedRows,
      };
    });
  };

  const handleDeleteRow = (index) => {
    setEffortDialog((prev) => {
      if (prev.rows.length === 1) {
        return prev;
      }

      return {
        ...prev,
        rows: prev.rows.filter((_, i) => i !== index),
      };
    });
  };

  const handleEffortSubmit = async () => {
    // Check for empty values
    const invalidRow = effortDialog.rows.find(
      (row) =>
        !row.type?.trim() ||
        row.effort === "" ||
        row.effort === null ||
        row.effort === undefined,
    );

    if (invalidRow) {
      toastMessage(
        "Please provide both Type and Effort for all rows.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
      return;
    }

    try {
      setEffortLoading(true);
      await postEffortDetails({
        ticket_id: effortDialog.ticketId,
        updated_by: firstName,
        efforts: effortDialog.rows,
        overAllEndDate: dayjs(overallEndDate, "DD-MM-YYYY").format(
          "YYYY-MM-DD",
        ),
      });
      toastMessage(
        "Efforts saved successfully.",
        {
          backgroundColor: "var(--primary-unilever-color)",
          textColor: "#fff",
        },
        3000,
      );
      handleCloseEffortDialog();
      await fetchTickets(true);
    } catch (error) {
      toastMessage(
        "Failed to save efforts.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    } finally {
      setEffortLoading(false);
    }
  };

  const openInvalidDialog = (ticketId, category) => {
    setInvalidDialog({
      open: true,
      ticketId,
      category,
      reason: "",
      othersReason: "",
    });
  };

  const closeInvalidDialog = () => {
    setInvalidDialog({
      open: false,
      ticketId: null,
      category: "",
      reason: "",
      othersReason: "",
    });
  };

  const handleInvalidSubmit = async () => {
    if (!invalidDialog.reason) {
      toastMessage(
        "Please select a reason.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
      return;
    }

    if (!invalidDialog.othersReason.trim()) {
      toastMessage(
        "Please enter comments.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
      return;
    }
    try {
      await updateTicketStatus({
        ticket_id: invalidDialog.ticketId,
        new_status: "Invalid",
        updated_by: firstName,
        category: invalidDialog.category,
        invalid_reason_type: invalidDialog.reason,
        invalid_reason: invalidDialog.othersReason,
      });
      updateTicketInPages(invalidDialog.ticketId, (ticket) => ({
        ...ticket,
        status: "Invalid",
      }));
      closeInvalidDialog();
      await fetchTickets(true);
    } catch (invalidError) {
      toastMessage(
        "Failed to mark ticket as invalid.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
      console.log("invalidError", invalidError);
    }
  };

  const handleResetFilters = () => {
    setCategoryFilter("");
    setStatusFilter("");
    setAssignedFilter("");
    setPageFilter("");
    setSearchText("");
    setPage(1);
    setEpicNameFilter("");
  };

  const handleExportReport = async () => {
    try {
      setExportLoading(true);
      if (
        exportDialog.fromDate &&
        exportDialog.toDate &&
        dayjs(exportDialog.toDate).isBefore(dayjs(exportDialog.fromDate), "day")
      ) {
        toastMessage(
          "To Date cannot be less than From Date",
          {
            backgroundColor: "var(--high-critical)",
            textColor: "#fff",
          },
          3000,
        );
        return;
      }

      if (
        exportDialog.fromDate &&
        dayjs(exportDialog.fromDate).isBefore(
          dayjs().subtract(2, "month"),
          "day",
        )
      ) {
        toastMessage(
          "From Date cannot be older than 2 months",
          {
            backgroundColor: "var(--high-critical)",
            textColor: "#fff",
          },
          3000,
        );
        return;
      }

      if (
        exportDialog.toDate &&
        dayjs(exportDialog.toDate).isAfter(dayjs(), "day")
      ) {
        toastMessage(
          "To Date cannot be greater than today",
          {
            backgroundColor: "var(--high-critical)",
            textColor: "#fff",
          },
          3000,
        );
        return;
      }

      const payload = {
        from_date: exportDialog.fromDate,
        to_date: exportDialog.toDate,
        category: exportDialog.category,
        reported_by: exportDialog.reportedBy,
        page_name: exportDialog.pageName,
        assigned_to: exportDialog.assignedTo,
        status: exportDialog.status,
        sla_status: exportDialog.slaStatus,
      };

      await exportTicketReport(payload);

      setExportDialog({
        open: false,
        fromDate: new Date(),
        toDate: new Date(),
        category: [],
        reportedBy: [],
        pageName: [],
        assignedTo: [],
        status: [],
        slaStatus: [],
      });
    } catch (err) {
      toastMessage(
        "Failed to export report",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    } finally {
      setExportLoading(false);
    }
  };

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleHolidayDialogOpen = () => {
    handleMenuClose();

    setHolidayDialog({
      open: true,
    });
  };

  const handleHolidayDialogClose = () => {
    setHolidayDialog({
      open: false,
    });

    setHolidayFile(null);
    setHolidayPayload([]);
  };

  const handleHolidayFileUpload = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    try {
      const fileData = await readXlsxFile(file);

      let rows = [];
      if (fileData?.[0]?.data?.length) {
        rows = fileData?.[0]?.data;
      }

      const headerRow = rows.find(
        (row) =>
          row?.includes("Sr. No.") &&
          row?.includes("Holiday") &&
          row?.includes("Date") &&
          row?.includes("Day"),
      );

      if (!headerRow) {
        throw new Error("Invalid template");
      }

      const headerIndex = rows.findIndex(
        (row) =>
          row?.includes("Sr. No.") &&
          row?.includes("Holiday") &&
          row?.includes("Date") &&
          row?.includes("Day"),
      );

      const holidayRows = rows.slice(headerIndex + 1);

      const mapHolidayRow = (row) => ({
        holiday_name: row[1],
        holiday_date: dayjs(row[2], "DD-MM-YYYY").format("YYYY-MM-DD"),
        day: row[3],
      });

      const holidays = holidayRows
        .filter((row) => row?.[1] && row?.[2])
        .map(mapHolidayRow);

      setHolidayFile(file);
      setHolidayPayload(holidays);
    } catch (error) {
      toastMessage(
        error instanceof Error ? error?.message : "Invalid Holiday Template",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const handleHolidaySubmit = async () => {
    try {
      const payload = {
        holidays: holidayPayload,
        uploaded_by: firstName,
      };

      await updateHolidaysList(payload);

      toastMessage(
        "Holiday list uploaded successfully",
        {
          backgroundColor: "var(--primary-unilever-color)",
          textColor: "#fff",
        },
        3000,
      );

      handleHolidayDialogClose();
    } catch (error) {
      toastMessage(
        "Failed to upload holiday list",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const handleBauTeamDialogOpen = async () => {
    handleMenuClose();

    setBauTeamDialog({
      open: true,
    });
    try {
      const response = await getInternalTeam();
      setInternalTeam(response?.ey_team_members);
    } catch (error) {
      toastMessage(
        "Failed to fetch BAU Team details",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const handleBauTeamDialogClose = () => {
    setBauTeamRows(bauTeamDetails);
    setEditingRows({});
    setBauTeamDialog({
      open: false,
    });
  };

  const handleBauMemberChange = (index, field, value) => {
    setBauTeamRows((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return updated;
    });
  };

  const handleDeleteBauMember = (index) => {
    setBauTeamRows((prev) => prev.filter((_, i) => i !== index));
    setEditingRows({});
  };

  const handleRowSave = (index) => {
    const member = bauTeamRows[index];

    const validUser = internalTeam.find(
      (user) =>
        user.id === member.user_id &&
        user.email.toLowerCase() === member.email.toLowerCase() &&
        user.name === member.name,
    );

    if (!validUser) {
      toastMessage(
        "The selected member is already a BAU team member.",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
      return;
    }

    setEditingRows({});
  };

  const handleActiveChange = (index, checked) => {
    setBauTeamRows((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        active: checked,
      };

      return updated;
    });
  };

  const handleOpenRcaDialog = () => setRcaDialog(true);
  const handleCommentTextChange = (e) => setNewComment(e.target.value);

  const handleUpdateTicket = async (ticketId, field, value) => {
    try {
      await updateTicketDetails({
        ticket_id: ticketId,
        [field]: value,
        updated_by: userInfo?.name || firstName,
      });

      await fetchTickets(true);

      setTicketViewDialog((prev) => ({
        ...prev,
        ticket: {
          ...prev.ticket,
          [field]: value,
        },
      }));

      toastMessage(
        "Ticket updated successfully",
        {
          backgroundColor: "var(--primary-unilever-color)",
          textColor: "#fff",
        },
        3000,
      );
    } catch (error) {
      toastMessage(
        "Failed to update ticket",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const handleAddBauMember = () => {
    setBauTeamRows((prev) => [
      {
        isSaved: false,
        name: "",
        role: "",
        email: "",
        active: true,
        isNew: true,
      },
      ...prev,
    ]);

    setEditingRows((prev) => ({
      ...prev,
      0: true,
    }));
  };

  const handleSaveBauMember = async () => {
    try {
      await syncBauTeamdetails({
        bau_team: bauTeamRows,
      });

      await fetchBauTeamDetails();
      handleBauTeamDialogClose();

      setTimeout(
        () =>
          toastMessage(
            "BAU team member saved successfully",
            {
              backgroundColor: "var(--primary-unilever-color)",
              textColor: "#fff",
            },
            3000,
          ),
        1000,
      );
    } catch (error) {
      console.error(error);
      const message =
        error instanceof Error
          ? error.message
          : "Failed to save BAU team member";
      toastMessage(
        message,
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const openTicketViewDialog = async (ticket) => {
    setTicketViewDialog({
      open: true,
      ticket,
    });

    setTicketDetailsLoading(true);

    try {
      const response = await getTicketDetails({
        ticket_id: ticket.ticket_id,
      });

      setTicketDetails(response);
    } catch (error) {
      const message =
        error instanceof Error
          ? error?.message
          : "Failed to load ticket details";

      toastMessage(
        message,
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    } finally {
      setTicketDetailsLoading(false);
    }
  };

  const closeTicketViewDialog = () => {
    setTicketViewDialog({
      open: false,
      ticket: null,
    });

    setNewComment("");
  };

  const handleAddComment = async (id) => {
    try {
      await postTicketComment({
        ticket_id: id,
        comment: newComment,
        commented_by: firstName,
      });

      setNewComment("");

      const response = await getTicketDetails({
        ticket_id: id,
      });

      setTicketDetails(response);

      toastMessage(
        "Comment added successfully",
        {
          backgroundColor: "var(--primary-unilever-color)",
          textColor: "#fff",
        },
        3000,
      );
    } catch (commentError) {
      const message =
        error instanceof Error ? error?.message : "Failed to add comment.";
      toastMessage(
        message,
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const handleInvalidReasonChange = (e, type) =>
    setInvalidDialog((prev) => ({
      ...prev,
      [type]: e.target.value,
    }));

  const handleSaveRca = async () => {
    try {
      await saveTicketRca({
        ticket_id: ticketViewDialog.ticket.ticket_id,
        rca: rcaText,
      });
      setRcaText("");

      setTicketDetails((prev) => {
        const copyTicket = { ...prev["ticket"] };
        copyTicket["ticket"] = { ...prev["ticket"], rca: rcaText };
        return copyTicket;
      });

      const response = await getTicketDetails({
        ticket_id: ticketViewDialog.ticket.ticket_id,
      });

      setTicketDetails(response);

      toastMessage(
        "RCA saved successfully",
        {
          backgroundColor: "var(--primary-unilever-color)",
          textColor: "#fff",
        },
        3000,
      );

      setRcaDialog(false);
    } catch (error) {
      toastMessage(
        "Failed to save RCA",
        {
          backgroundColor: "var(--high-critical)",
          textColor: "#fff",
        },
        3000,
      );
    }
  };

  const handleRcaTextChange = (e) => setRcaText(e.target.value);
  const handleRcaDialogClose = () => setRcaDialog(false);

  const handleCloseCalendar = () => {
    setCalendarAnchor(null);
    setActiveDateField(null);
  };

  const handleCloseExportDialog = () =>
    setExportDialog({
      open: false,
      fromDate: new Date(),
      toDate: new Date(),
      category: [],
      reportedBy: [],
      pageName: [],
      assignedTo: [],
      status: [],
      slaStatus: [],
    });

  const handleOpenCalendar = (e, type) => openCalendar(e, type);

  if (accessLoading) {
    return <Skeleton height={400} />;
  }

  if (!userAccess?.canView) {
    return (
      <Box p={3}>
        <Typography color="error">
          You do not have access to this module.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 2, py: 0.5, ...baseFontStyle }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={snackbarOpen}
        message={state.message}
        key={vertical + horizontal}
        slotProps={{
          content: {
            sx: {
              backgroundColor,
              color: textColor,
            },
          },
        }}
      />
      <Box sx={{ mb: 1 }}>
        <KpiCards
          kpis={ticketKpis?.kpi_summary}
          loading={kpiLoading}
          onStatusFilter={({ category, status }) => {
            const alreadySelected =
              categoryFilter === category &&
              statusFilter.toLowerCase() === status.toLowerCase();

            if (alreadySelected) {
              setCategoryFilter("");
              setStatusFilter("");
            } else {
              setCategoryFilter(category);
              setStatusFilter(status);
            }

            setPage(1);
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mb: 2,
          alignItems: "flex-start",
        }}
      >
        <FormControl
          size="small"
          sx={{
            width: 150,
            flexShrink: 0,
            backgroundColor: "#ffffff",
            ...baseFontStyle,
          }}
        >
          <InputLabel
            id="category-filter-label"
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            Category
          </InputLabel>
          <Select
            labelId="category-filter-label"
            label="Category"
            value={categoryFilter}
            onChange={(event) => setCategoryFilter(event.target.value)}
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            <MenuItem value="" sx={menuItemTextStyle}>
              All
            </MenuItem>
            {categoryOptions.map((option) => (
              <MenuItem key={option} value={option} sx={menuItemTextStyle}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          size="small"
          sx={{
            width: 150,
            flexShrink: 0,
            backgroundColor: "#ffffff",
            ...baseFontStyle,
          }}
        >
          <InputLabel
            id="status-filter-label"
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            Status
          </InputLabel>
          <Select
            labelId="status-filter-label"
            label="Status"
            value={statusFilter}
            onChange={(event) => setStatusFilter(event.target.value)}
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            <MenuItem value="" sx={menuItemTextStyle}>
              All
            </MenuItem>
            {statusOptions.map((option) => (
              <MenuItem key={option} value={option} sx={menuItemTextStyle}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          size="small"
          sx={{
            width: 150,
            flexShrink: 0,
            backgroundColor: "#ffffff",
            ...baseFontStyle,
          }}
        >
          <InputLabel
            id="status-filter-label"
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            Epic Name
          </InputLabel>
          <Select
            labelId="status-filter-label"
            label="Epic Name"
            value={epicNameFilter}
            onChange={(event) => setEpicNameFilter(event.target.value)}
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            <MenuItem value="" sx={menuItemTextStyle}>
              All
            </MenuItem>
            {EPICS_DATA.map((option) => (
              <MenuItem key={option} value={option} sx={menuItemTextStyle}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          size="small"
          sx={{
            width: 150,
            flexShrink: 0,
            backgroundColor: "#ffffff",
            ...baseFontStyle,
          }}
        >
          <InputLabel
            id="assigned-filter-label"
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            Assigned
          </InputLabel>
          <Select
            labelId="assigned-filter-label"
            label="Assigned"
            value={assignedFilter}
            onChange={(event) => setAssignedFilter(event.target.value)}
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            <MenuItem value="" sx={menuItemTextStyle}>
              All
            </MenuItem>
            {assignedOptions.map((option) => (
              <MenuItem key={option} value={option} sx={menuItemTextStyle}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          size="small"
          sx={{
            width: 150,
            flexShrink: 0,
            backgroundColor: "#ffffff",
            ...baseFontStyle,
          }}
        >
          <InputLabel
            id="page-filter-label"
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            Page
          </InputLabel>
          <Select
            labelId="page-filter-label"
            label="Page"
            value={pageFilter}
            onChange={(event) => setPageFilter(event.target.value)}
            sx={{ ...baseFontStyle, fontSize: "0.75rem", fontWeight: 400 }}
          >
            <MenuItem value="" sx={menuItemTextStyle}>
              All
            </MenuItem>
            {pageOptions.map((option) => (
              <MenuItem key={option} value={option} sx={menuItemTextStyle}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <IconButton
          size="small"
          onClick={handleResetFilters}
          title="Reset Filters"
          sx={{
            alignSelf: "center",
            backgroundColor: "#ffffff",
            p: 0.5,
            borderRadius: "6px",
          }}
        >
          <ReplayTwoToneIcon fontSize="small" />
        </IconButton>

        <TextField
          size="small"
          label="Search tickets"
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          sx={{
            width: 200,
            flexShrink: 0,
            backgroundColor: "#ffffff",
            ml: "auto",
            ...baseFontStyle,
          }}
          inputProps={{
            style: {
              ...baseFontStyle,
              fontSize: "0.75rem",
              fontWeight: 400,
            },
          }}
          InputLabelProps={{
            sx: {
              ...baseFontStyle,
              fontSize: "0.75rem",
              fontWeight: 400,
            },
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 16 }} />
                </InputAdornment>
              ),
            },
          }}
        />
        <Box
          sx={{
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            alignItems: "center",
            width: 100,
            p: 0.5,
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            transition: "all 0.3s ease",
            borderRadius: "6px",
            cursor: "pointer",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 0.75rem 32px rgba(0,0,0,0.18)",
            },
          }}
          onClick={() =>
            setExportDialog((prev) => ({
              ...prev,
              open: true,
            }))
          }
        >
          <IconButton size="small" title="Export">
            <img src={newExcel} alt="" style={{ width: 16, height: 16 }} />
          </IconButton>
          <Typography
            sx={{
              ...baseFontStyle,
              fontSize: "14px",
              fontWeight: 400,
              alignSelf: "center",
            }}
          >
            Export
          </Typography>
        </Box>
        {(userAccess?.canUpdateBauList ||
          userAccess?.canUpdateHolidaysList) && (
          <>
            <IconButton
              size="small"
              title="aside-menu"
              onClick={handleMenuClick}
            >
              <MoreVertTwoToneIcon />
            </IconButton>

            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              {userAccess?.canUpdateBauList && (
                <MenuItem
                  sx={menuItemTextStyle}
                  onClick={handleBauTeamDialogOpen}
                >
                  BAU Team
                </MenuItem>
              )}

              {userAccess?.canUpdateHolidaysList && (
                <MenuItem
                  sx={menuItemTextStyle}
                  onClick={handleHolidayDialogOpen}
                >
                  Holidays List
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </Box>
      {loading ? (
        <TableSkeleton />
      ) : error ? (
        <Box sx={{ p: 3 }}>
          <Typography color="error">{error}</Typography>
        </Box>
      ) : (
        <>
          <TicketsTable
            sortedTickets={sortedTickets}
            sortBy={sortBy}
            sortDirection={sortDirection}
            handleRequestSort={handleRequestSort}
            severityEdit={severityEdit}
            setSeverityedit={setSeverityedit}
            handleSeverityChange={handleSeverityChange}
            fetchTickets={fetchTickets}
            userAccess={userAccess}
            handleOpenEffortDialog={handleOpenEffortDialog}
            setEffortDialog={setEffortDialog}
            formatDate={formatDate}
            pendingAssignments={pendingAssignments}
            handleAssignmentSelection={handleAssignmentSelection}
            handleAssignmentDone={handleAssignmentDone}
            openAssignment={openAssignment}
            setOpenAssignment={setOpenAssignment}
            bauTeamDetails={bauTeamDetails}
            handleStatusChange={handleStatusChange}
            openInvalidDialog={openInvalidDialog}
            openTicketViewDialog={openTicketViewDialog}
            getSLAStatusStyle={getSLAStatusStyle}
            menuItemTextStyle={menuItemTextStyle}
          />
          {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <TablePagination
              component="div"
              count={totalRecords}
              page={page - 1}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={() => {}}
              rowsPerPageOptions={[rowsPerPage]}
              labelRowsPerPage="Rows per page"
              labelDisplayedRows={({ from, to, count }) =>
                `Page ${page} of ${Math.max(1, totalPagesCount)}`
              }
              showFirstButton
              showLastButton
              sx={{ px: 2, py: 1, width: "100%", ...baseFontStyle }}
            />
          </Box> */}
        </>
      )}
      {/* Effort details Dialog */}
      <EffortDetails
        effortDialog={effortDialog}
        effortLoading={effortLoading}
        overallEndDate={overallEndDate}
        totalHours={totalHours}
        overallStartDate={overallStartDate}
        handleCloseEffortDialog={handleCloseEffortDialog}
        handleEffortChange={handleEffortChange}
        handleDeleteRow={handleDeleteRow}
        handleEffortSubmit={handleEffortSubmit}
        handleAddEffortRow={handleAddEffortRow}
      />

      {/* Invalid ticket Dialog */}
      <InvalidReason
        invalidDialog={invalidDialog}
        closeInvalidDialog={closeInvalidDialog}
        handleInvalidReasonChange={handleInvalidReasonChange}
        handleInvalidSubmit={handleInvalidSubmit}
      />

      {/* Export KPI & Ticket Report */}
      <ExportTicketDetails
        exportDialog={exportDialog}
        reportedByList={ticketKpis?.reported_by_values || []}
        exportLoading={exportLoading}
        pageOptions={pageOptions}
        bauTeamDetails={bauTeamDetails}
        handleCloseExportDialog={handleCloseExportDialog}
        handleExportFieldChange={handleExportFieldChange}
        handleExportReport={handleExportReport}
        handleOpenCalendar={handleOpenCalendar}
      />
      {/* Holidays list upload */}
      <HolidayListupload
        holidayDialog={holidayDialog}
        holidayFile={holidayFile}
        disableSubmit={holidayPayload?.length}
        handleHolidaySubmit={handleHolidaySubmit}
        handleHolidayDialogClose={handleHolidayDialogClose}
        handleHolidayFileUpload={handleHolidayFileUpload}
      />
      {/* BAU Team Dialog*/}
      <BauTeamMembers
        bauTeamDialog={bauTeamDialog}
        internalTeam={internalTeam}
        bauTeamRows={bauTeamRows}
        editingRows={editingRows}
        handleBauTeamDialogClose={handleBauTeamDialogClose}
        handleAddBauMember={handleAddBauMember}
        handleBauMemberChange={handleBauMemberChange}
        handleActiveChange={handleActiveChange}
        handleRowSave={handleRowSave}
        handleSaveBauMember={handleSaveBauMember}
        handleDeleteBauMember={handleDeleteBauMember}
        disableSave={bauTeamDetails?.length === bauTeamRows?.length}
      />
      {/* Ticket View Dialog */}
      <ViewTicketDetails
        ticketViewDialog={ticketViewDialog}
        closeTicketViewDialog={closeTicketViewDialog}
        ticketDetailsLoading={ticketDetailsLoading}
        userAccess={userAccess}
        ticketDetails={ticketDetails}
        newComment={newComment}
        handleOpenRcaDialog={handleOpenRcaDialog}
        handleAddComment={handleAddComment}
        handleCommentTextChange={handleCommentTextChange}
        handleUpdateTicket={handleUpdateTicket}
      />
      {/* RCA Dialog */}
      <RcaDialog
        rcaDialog={rcaDialog}
        rcaText={rcaText}
        handleRcaDialogClose={handleRcaDialogClose}
        handleRcaTextChange={handleRcaTextChange}
        handleSaveRca={handleSaveRca}
      />
      {/* calendar popover */}
      <CustomCalendar
        handleCloseCalendar={handleCloseCalendar}
        calendarAnchor={calendarAnchor}
        activeDateField={activeDateField}
        exportDialog={exportDialog}
        handleDateSelect={handleDateSelect}
        twoMonthsAgo={twoMonthsAgo}
      />
    </Box>
  );
}
